import { render, staticRenderFns } from "./MusicManage.vue?vue&type=template&id=1c120d0a&scoped=true&"
import script from "./MusicManage.vue?vue&type=script&lang=js&"
export * from "./MusicManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c120d0a",
  null
  
)

export default component.exports